import bannerUrl from "./assets/BEV_FY26_LCH_Campaign_Family_Static_ALL_GCM_chr_320x50_300dpi.jpg";
import AdBanner from "./AdBanner";
import { useGameConfig } from "game-config";

interface ToyotaAdBannerProps {
  showDisclaimer?: boolean;
}

export default function ToyotaAdBanner({
  showDisclaimer = true,
}: ToyotaAdBannerProps) {
  const { showSponsor } = useGameConfig();
  const isShowingSponsor = showSponsor();

  return (
    <AdBanner
      enabled={isShowingSponsor}
      showDisclaimer={showDisclaimer}
      clickthroughUrl="https://www.toyota.com/electrified-vehicles?utm_source=ted_games&utm_medium=display&utm_campaign=toyota_bev_fy26"
      imgUrl={bannerUrl}
      altText="Toyota — Explore electrified vehicles"
      ariaLabel="Toyota — Explore electrified vehicles (opens in a new tab)"
      className="text-black"
    />
  );
}
